@if (message(); as text) {
  <div
    role="alert"
    class="flex items-center gap-2 border-t border-outline-variant bg-error-container/40 px-6 py-3"
  >
    <mat-icon fontIcon="error" class="shrink-0 text-error! text-[20px]! w-5! h-5!" />
    <p class="text-sm leading-relaxed text-on-surface">{{ text }}</p>
  </div>
}
